import { getSignedURL } from 'api/endpoints/upload';
import { useCallback, useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setLoading } from 'store/actions/common';
import { formatTime, handleVideoSurvey } from 'utils/helper';

const MutedIcon = require('assets/resources/Muted.svg').default;
const PauseIcon = require('assets/resources/Pause.svg').default;
const PlayIcon = require('assets/resources/Play.svg').default;
const PlayVideo = require('assets/resources/PlayVideo.svg').default;
const UnmutedIcon = require('assets/resources/Unmuted.svg').default;

const VideoPlayer = ({ url, item }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);
  const [isMuted, setIsMuted] = useState(false);
  const [isPlay, setIsPlay] = useState(false);
  const [isEnded, setIsEnded] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [durationPercentage, setDurationPercentage] = useState(0);
  const [widthCurrentVideo, setWidthCurrentVideo] = useState(0);
  const videoRef = useRef(null);
  const progressRef = useRef(null);
  const [src, setSrc] = useState('');

  const setUpVideo = () => {
    if (videoRef.current) {
      setWidthCurrentVideo(videoRef.current.clientWidth);
      setDuration(Math.floor(videoRef.current.duration));
    }
  };

  const onPlay = () => {
    if (isEnded) {
      setIsEnded(false);
      progressRef.current.style.width = '0%';
    }
    setTimeout(() => {
      progressRef.current.classList.add('transition-all-custom');
      videoRef.current.play();
      setIsPlay(true);
    }, 100);
  };

  const onPause = () => {
    setIsPlay(false);
    videoRef.current.pause();
  };

  const onEnded = () => {
    setIsPlay(false);
    setIsEnded(true);
    setTimeout(() => {
      progressRef.current?.classList.remove('transition-all-custom');
    }, 300);
  };

  const onTimeUpdate = () => {
    setCurrentTime(videoRef.current.currentTime);
    setDurationPercentage((videoRef.current.currentTime / videoRef.current.duration) * 100);
  };

  const onVideoClick = () => {
    if (isPlay) {
      onPause();
    } else {
      onPlay();
    }
  };

  const onLoadStart = () => {
    dispatch(setLoading({ isOpen: true }));
  };

  const onLoadedData = () => {
    dispatch(setLoading({ isOpen: false }));
  };

  const handleLoadImage = useCallback(async () => {
    if (url) {
      setSrc(url);
    } else {
      const signedURL = await getSignedURL({ blob_name: item.source_blob, bucket_name: item.source_bucket });
      const { signed_url, etag } = signedURL.data;
      const videos = await handleVideoSurvey([{ signed_url, etag }]);
      if (videos.length > 0) {
        videos[0]?.url_preview && setSrc(videos[0].url_preview);
      }
    }
  }, [item.source_blob, item.source_bucket]);

  useEffect(() => {
    handleLoadImage();
  }, [handleLoadImage]);

  return (
    src && (
      <>
        <video
          onLoadStart={onLoadStart}
          onLoadedData={onLoadedData}
          onLoadedMetadata={setUpVideo}
          muted={isMuted}
          onClick={onVideoClick}
          onEnded={onEnded}
          onTimeUpdate={onTimeUpdate}
          playsInline
          autoPlay={true}
          controls={false}
          ref={videoRef}
          className="max-h-167.5"
          onPlay={onPlay}
        >
          <source src={src} type="video/mp4" />
        </video>
        {!loading.isOpen && (
          <>
            {!isPlay && (
              <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center cursor-pointer" onClick={onPlay}>
                <img src={PlayVideo} alt="play video" width={56} height={56} />
              </div>
            )}
            <div className="absolute bottom-5 left-0 w-full flex justify-center items-center">
              <div>
                <div className="flex justify-between items-center">
                  <div className="flex justify-center items-center gap-2">
                    {isPlay ? (
                      <img className="cursor-pointer" src={PauseIcon} alt="image" width={32} height={32} onClick={onPause} />
                    ) : (
                      <img className="cursor-pointer" src={PlayIcon} alt="image" width={32} height={32} onClick={onPlay} />
                    )}
                    <span className="time text-white text-shadow-lg/30 ">
                      {formatTime(Math.floor(currentTime))}/{formatTime(Math.floor(duration))}
                    </span>
                  </div>
                  <div className="flex justify-center items-center gap-2">
                    {isMuted ? (
                      <img className="cursor-pointer" src={MutedIcon} alt="image" width={32} height={32} onClick={() => setIsMuted(!isMuted)} />
                    ) : (
                      <img className="cursor-pointer" src={UnmutedIcon} alt="image" width={32} height={32} onClick={() => setIsMuted(!isMuted)} />
                    )}
                  </div>
                </div>
                <div className="mt-4" style={{ width: `${widthCurrentVideo / 1.0339}px` }}>
                  <div className="timebar w-full h-[6px] bg-black/30 rounded-full">
                    <div
                      ref={progressRef}
                      className="timebar-progress h-full bg-white rounded-full w-0"
                      style={{ width: `${durationPercentage}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )
  );
};

export default VideoPlayer;
